/**
 * Garden Events section: multi-select filters (location and event type).
 * Show events that match any selected location AND any selected event type.
 * No selection = show all for that dimension.
 */
(function () {
  const sections = document.querySelectorAll('[data-garden-events]');

  sections.forEach((section) => {
    const showFilters = section.dataset.showFilters === 'true';
    const list = section.querySelector('[data-garden-events-list]');
    const cards = section.querySelectorAll('[data-garden-event-card]');

    if (!list || !cards.length) return;

    if (showFilters) {
      const getCheckedLocations = () =>
        Array.from(section.querySelectorAll('[data-filter="location"]')).filter((el) => el.checked).map((el) => el.value);
      const getCheckedTypes = () =>
        Array.from(section.querySelectorAll('[data-filter="event-type"]')).filter((el) => el.checked).map((el) => el.value);

      const applyFilters = () => {
        const selectedLocations = getCheckedLocations();
        const selectedTypes = getCheckedTypes();
        const hasLocationFilter = selectedLocations.length > 0;
        const hasTypeFilter = selectedTypes.length > 0;
        let visibleCount = 0;

        cards.forEach((card) => {
          const cardLocations = (card.dataset.locations || '').split(',').map((s) => s.trim()).filter(Boolean);
          const cardTypes = (card.dataset.eventTypes || '').split(',').map((s) => s.trim()).filter(Boolean);
          const matchLocation = !hasLocationFilter || cardLocations.some((loc) => selectedLocations.includes(loc));
          const matchType = !hasTypeFilter || cardTypes.some((t) => selectedTypes.includes(t));
          const show = matchLocation && matchType;

          card.dataset.hiddenByFilter = show ? 'false' : 'true';
          if (show) visibleCount++;
        });

        let noResults = list.querySelector('.garden-events__no-results');
        if (visibleCount === 0 && (hasLocationFilter || hasTypeFilter)) {
          if (!noResults) {
            noResults = document.createElement('p');
            noResults.className = 'garden-events__no-results';
            noResults.textContent = 'No events match your filters.';
            list.appendChild(noResults);
          }
          noResults.classList.add('is-visible');
        } else if (noResults) {
          noResults.classList.remove('is-visible');
        }
      };

      section.querySelectorAll('.garden-events__filter-checkbox').forEach((input) => {
        input.addEventListener('change', applyFilters);
      });
    }
  });
})();
